import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, DownloadIcon } from "./DealerIcons"

/* Barcode */
import Barcode from "react-barcode"

/* HTML to PNG */
import { toPng } from "html-to-image"

/* Download JS */
import download from "downloadjs"


/* Widget Dealer QR */
class DealerQR extends Component {

    constructor() {
        super()
        this.state = { visible: false, item: null }
    }

    /* Open Action */
    open = (item) => {
        this.setState({ visible: true, item })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, item: null })
    }

    /* Download PNG */
    downloadPNG = () => {

        /* Fields */
        const { item } = this.state
        const card = document.getElementById("qr-image")

        /* Check Card */
        if (!card) {
            return
        }

        /* Save File */
        toPng(card).then((url) => {
            download(url, `${item.name}-qr-code.png`)
        })

    }

    render = () => {

        /* Fields */
        const { visible, item } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="dealer--modal wide"
                overlayClassName="dealer--overlay"
                closeTimeoutMS={200}
            >

                <div className="dealer--modal-header">

                    <div>
                        <h2>{t("dealer.qrCode")}</h2>
                        <p>{item ? item.name : ""}</p>
                    </div>

                    <div onClick={() => this.close()} className="dealer--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                {item &&
                    <div className="dealer--modal-body center">

                        <div className="dealer--card" id="qr-image">

                            <div className="dealer--card-head">
                                <div className="dealer--card-logo">Cuba<span>GO</span></div>
                                <img src="/images/croupier-qr.png" alt="Dealer" />
                            </div>

                            <Barcode value={utils.checkValue(item.pincode, "")} displayValue={false} format="CODE39" />

                            <div className="dealer--card-bottom">

                                <div className="dealer--card-box">
                                    <div className="dealer--card-text">Dealer</div>
                                    <div className="dealer--card-value">{utils.checkValue(item.name, "")}</div>
                                </div>

                                <div className="dealer--card-box">
                                    <div className="dealer--card-text">Pincode</div>
                                    <div className="dealer--card-value">{utils.checkValue(item.pincode, "")}</div>
                                </div>

                            </div>

                        </div>

                    </div>
                }

                <div className="dealer--modal-footer">

                    <div onClick={() => this.close()} className="dealer--button ghost">{t("common.cancel")}</div>

                    <div onClick={() => this.downloadPNG()} className="dealer--button primary">
                        <DownloadIcon />
                        <span>{t("dealer.downloadPng")}</span>
                    </div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(DealerQR)
